export default __webpack_public_path__ + "static/thumb-landscape-67c01fd52f5e3a63322d8575a17b7687.jpg";